import clsx from "clsx"
import { useEffect, useRef } from "react"

import usePopover from "@molecules/Popover/Popover.store"

import styles from "./PopoverContent.module.scss"
import { PopoverContentProps } from "./PopoverContent.types"

export default function PopoverContent(props: PopoverContentProps) {
    const { priority, children, isVisible } = props

    const ref = useRef<HTMLDivElement>(null)

    const { setContentHeight } = usePopover()

    useEffect(() => {
        const element = ref.current

        if (!element) {
            return
        }

        const onResize = () => setContentHeight(element.scrollHeight)
        const resizeObserver = new ResizeObserver(onResize)

        if (isVisible) {
            resizeObserver.observe(element)
        } else {
            resizeObserver.unobserve(element)
        }

        return () => {
            resizeObserver.unobserve(element)
        }
    }, [isVisible])

    return (
        <div
            ref={ref}
            className={clsx(styles[priority], {
                [styles.visible]: isVisible,
            })}
        >
            {/* Dynamically renders the children passing down a boolean that indicates if the link should be active. */}
            {children(isVisible)}
        </div>
    )
}
